import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "d-flex align-items-center" }
const _hoisted_2 = { class: "m-0" }
const _hoisted_3 = { class: "text-muted" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h5", _hoisted_2, _toDisplayString(_ctx.candidate.name), 1),
      _cache[2] || (_cache[2] = _createElementVNode("span", { class: "ml-2 badge badge-pill badge-secondary" }, "Candidate", -1)),
      _cache[3] || (_cache[3] = _createElementVNode("div", { class: "flex-fill" }, null, -1)),
      _createElementVNode("button", {
        class: "btn btn-outline-secondary btn-icon btn-menu",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.invite && _ctx.invite(...args))),
        "data-toggle": "modal",
        "data-target": "#modal-new-invite",
        title: "Invite"
      }, [...(_cache[1] || (_cache[1] = [
        _createElementVNode("i", { class: "fas fa-user-plus" }, null, -1)
      ]))])
    ]),
    _createElementVNode("small", _hoisted_3, _toDisplayString(_ctx.candidate.email), 1)
  ]))
}